export const routes = [
    { path: 'dashboard', title: 'Dashboard', icon: 'design_app', class: '', roles: [{ role: 'ADMIN', isVisible: true }, { role: 'PATIENT', isVisible: true }, { role: 'PARTNER', isVisible: true }] },
    { path: 'Reporting', title: 'Reporting', icon: 'design_app', class: '', roles: [{ role: 'ADMIN', isVisible: true }] },
    { path: 'Eligibility', title: 'Eligibility', icon: 'design_app', class: '', roles: [{ role: 'ADMIN', isVisible: true }] },
    { path: 'Users', title: 'Users', icon: 'design_app', class: '', roles: [{ role: 'ADMIN', isVisible: true }] }


];